/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './tableView.module.scss';
import MagnifyingGlass from '../../../../Assets/images/svg/dar_magnifying.svg';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DataGridComponent from '../../../../Components/DataGrid/dataGrid';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { SKILL_CERT_PROFILE } from '../../../../Constants/strings';
import { useNavigate } from 'react-router-dom';

const TableView = () => {
  const initialNames = [
    { name: 'Vertical' },
    { name: 'Region' },
    { name: 'Industry' },
    { name: 'Deal name' },
    { name: 'Deal value' },
    { name: 'Deal status' },
  ];
  const [rows, setRows] = useState([]);
  const [tableNames, setTableNames] = useState(initialNames);
  const [isMobileView, setIsMobileView] = useState(false);
  const [openSelects, setOpenSelects] = useState({});
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const dataRows = [
    {
      id: 1,
      DEAL_NAME: 'ABC Corp',
      DEAL_VALUE: '50000',
      DEAL_STATUS: 'Pending',
      VERTICAL: 'App mod',
      REGION: 'India',
      INDUSTRY: 'Banking',
    },
    {
      id: 2,
      DEAL_NAME: 'Xyz Bank',
      DEAL_VALUE: '50000',
      DEAL_STATUS: 'Pending',
      VERTICAL: 'Data mod',
      REGION: 'India',
      INDUSTRY: 'Banking',
    },
    {
      id: 3,
      DEAL_NAME: 'ANZ',
      DEAL_VALUE: '50000',
      DEAL_STATUS: 'Pending',
      VERTICAL: 'Data mod',
      REGION: 'India',
      INDUSTRY: 'Banking',
    },
  ];

  useEffect(() => {
    setRows(dataRows);
    checkMobileView();
    setTableNames(initialNames);
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const navigateRevenueOnView = (status) => {
    let selectedId = '1';
    if (status === 'Pending') {
      navigate('/deal-transition/dashboard/transition-form?id=' + selectedId);
    } else {
      navigate('/deal-transition/dashboard/details-view?id=' + selectedId);
    }
  };

  const handleSearchRevenue = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const formatRevenueFieldName = (name) => name.toUpperCase().replace(/\s+/g, '_');

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const rowsFiltered =
    searchText.length >= 1
      ? rows.filter((row) => {
          return (
            row?.DEAL_NAME?.toLowerCase().includes(searchText) ||
            row?.DEAL_STATUS?.toLowerCase().includes(searchText) ||
            row?.DEAL_VALUE?.toLowerCase().includes(searchText) ||
            row?.VERTICAL?.toLowerCase().includes(searchText) ||
            row?.REGION?.toLowerCase().includes(searchText) ||
            row?.INDUSTRY?.toLowerCase().includes(searchText)
          );
        })
      : rows;

  const handleRevenueSelectOpen = (id) => {
    setOpenSelects((prevState) => ({
      ...prevState,
      [id]: true, // Set the specific select to open
    }));
  };

  const handleRevenueSelectClose = (id) => {
    setOpenSelects((prevState) => ({
      ...prevState,
      [id]: false, // Set the specific select to close
    }));
  };

  const renderKeyboardArrowDownIcon = (openSelects, id) => {
    return (
      <KeyboardArrowDownIcon
        sx={{
          color: '#FF0000',
          fontSize: 20,
          transition: 'transform 0.3s',
          transform: openSelects[id]
            ? 'rotate(180deg)'
            : 'rotate(0deg)',
        }}
      />
    )
  }
  const revenueColumns = tableNames.map(({ name }) => ({
    field: formatRevenueFieldName(name),
    headerName: name,
    width: 150,
    flex: !isMobileView ? 0.1 : undefined,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      switch (name) {
        case 'Deal status': {
          let validStatusValues = ['active', 'inactive', 'in_progress'];
          let value = validStatusValues.includes(params.value)
            ? params.value
            : 'active';

          return (
            <Select
              key={params.id}
              sx={{
                padding: '0px !important',
                fontSize: 14,
                height: 30,
                borderRadius: 2,
                backgroundColor: '#FDEFEF',
                textAlign: 'start',
                color: '#FF2E2E',
                border: 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                  padding: 0,
                },
                '& .MuiSelect-select': { padding: '5px !important' },
              }}
              IconComponent={()=>renderKeyboardArrowDownIcon(openSelects, params.id)}
              onOpen={() => handleRevenueSelectOpen(params.id)}
              onClose={() => handleRevenueSelectClose(params.id)}
              value={value}
              input={<OutlinedInput label="Tag" />}
              renderValue={(value) => value}
              onChange={(event) =>
                handleChangeStatus(params.id, event.target.value)
              }
            >
              <MenuItem key="active" value="active">
                Active
              </MenuItem>
              <MenuItem key="inactive" value="inactive">
                Inactive
              </MenuItem>
              <MenuItem key="in_progress" value="in_progress">
                In Progress
              </MenuItem>
            </Select>
          );
        }

        case 'Deal Name':
          return (
            <div key={params.id} className={styles['revenue-tableView-cellDesign-dealName']}>
              <div className={styles['revenue-tableView-cellDesign-dealName-dot']}></div>
              <div>{params.value}</div>
            </div>
          );

        default:
          return params.value;
      }
    },
  }));

  const sortColumnsFilter = revenueColumns.map((column) => column.field);

  const handleChangeStatus = (id, value) => {
    console.log(`Row ID: ${id}, New Status: ${value}`); // Handle the status change logic here
  };

  const revenueDataColumns = [
    ...revenueColumns,
    {
      headerName: 'Actions',
      type: 'number',
      headerClassName: !isMobileView ? '' : `${styles['action-column']} ${styles['revenue-tableView-action-headerWidth']}`,
      cellClassName: !isMobileView ? '': `${styles['action-cell']} ${styles['revenue-tableView-action-cellWidth']}`,
      flex: 0.07,
      renderCell: (params) => {
        const buttonText = SKILL_CERT_PROFILE.VIEW; // Otherwise, show view
        return (
          <button
            onClick={() => {
              const { STATUS } = params.row;
              navigateRevenueOnView(STATUS);
            }}
            className={styles['revenue-tableView-actions-viewButton']}
          >
            {buttonText}
          </button>
        );
      },
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const renderRevenueTableViewSearch = () => {
    return (
      <div
        className={`${styles['revenue-tableView-search-and-buttons']} ${styles['revenue-tableView-headerSection-flex']} ${styles['rowsFiltered-revenue-tableView']} ${styles['revenue-tableView-margin']}`}
        style={{ padding: '8px 12px' }}
      >
        <div className={styles['revenue-tableView-headerSection-main']}>
          <div className={`${styles['revenue-tableView-search']} ${styles['revenue-tableView-headerSection-mainSearchInput']}`}>
            <div className={styles['revenue-tableView-headerSection-search']}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="revenue-tableView-search-input"
                type="text"
                placeholder="Search..."
                onChange={handleSearchRevenue}
                className={styles['revenue-tableView-headerSection-searchInput']}
              />
            </div>
          </div>
        </div>
      </div>
    )
  };
  return (
    <div className="users-manage-outer-layer">
      <div className="users-manage">
        {renderRevenueTableViewSearch()}
        <div className={`${styles['revenue-tableView-data-grid-container']} ${styles['rowsFiltered-revenue-tableView']}}`}>
          {rowsFiltered && (
            <DataGridComponent
              dataRows={rowsFiltered}
              dataColumns={revenueDataColumns}
              isFilteredRows={rowsFiltered}
              sortFilterColumns={sortColumnsFilter}
              pageSize={10}
              isEdit={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TableView;
